<template>
    <div v-if="insight" class="journal-insight-bar">
        <v-icon class="journal-insight-icon" size="18" color="#1f1f1f">fa-regular fa-sparkles</v-icon>
        <p class="journal-insight-content">
            <span class="journal-insight-label">{{ $t('portfolioStats.insight') }} |</span>
            <span class="journal-insight-text">{{ message }}</span>
        </p>
    </div>
</template>

<script>
const MIN_TRADES = 10;

/**
 * Grey bar at the bottom of a Journal stats section (SFB-1288).
 * `insight` is { status: 'loading' | 'OK' | 'INSUFFICIENT_DATA', text, missing, trades }; without it
 * (not Pro, external journal, or the AI had nothing to say) nothing is rendered.
 */
export default {
    name: 'JournalInsightBar',
    props: {
        insight: { type: Object, default: null },
    },
    computed: {
        message() {
            if (!this.insight) {
                return '';
            }
            if (this.insight.status === 'loading') {
                return this.$t('journalInsights.loading');
            }
            if (this.insight.status === 'INSUFFICIENT_DATA') {
                return (this.insight.missing || [])
                    .map((code) => this.$t(`journalInsights.missing.${code}`, {
                        min: MIN_TRADES,
                        current: this.insight.trades || 0,
                    }))
                    .join(' ');
            }
            return this.insight.text;
        },
    },
};
</script>

<style lang="scss" scoped>
.journal-insight-bar {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin-top: 24px;
    padding: 16px 20px;
    background: #ebebeb;
    border-radius: 6px;
}

.journal-insight-icon {
    margin-top: 3px;
    flex-shrink: 0;
}

.journal-insight-content {
    margin: 0;
    font-family: 'Avenir', sans-serif;
    font-size: 16px;
    line-height: 1.55;
    color: #1f1f1f;
}

.journal-insight-label {
    margin-right: 6px;
    font-weight: 800;
}

.journal-insight-text {
    font-weight: 500;
}

@media (max-width: 599px) {
    .journal-insight-bar {
        padding: 14px 16px;
    }

    .journal-insight-content {
        font-size: 15px;
    }
}
</style>
